import type { Track, Album } from '@/hooks/useMusicLibrary';

const folderMap: Record<string, string> = {
  vibe_coding: 'vibe coding',
  neural_drift: 'neural drift',
  scripted_light: 'scripted light',
  soulful_lounge: 'soulful lounge',

  sufi_lofi: 'sufi lo-fi',
  relaxed_classical: 'relaxed neo-classical',
  deep_piano_focus: 'deep piano focus',
  cognitive_bloom: 'cognitive bloom',
  harmonic_field: 'harmonic field',
  healing_handpan: 'Healing Handpan',
  playground: 'playground',
  vibing_with_superintelligence: 'vibing with superintelligence',
};

export function getAlbumCoverPath(albumSlug: string): string {
  return `/assets/albums/${albumSlug}.webp`;
}

export function getTrackPath(
  track: Track | undefined,
  selectedAlbum: Album | undefined,
  isPro: boolean,
  audioQuality: 'mp3' | 'wav'
): string | null {
  if (!track || !selectedAlbum) return null;

  const albumSlugForPath =
    selectedAlbum.albumId === 'favorites'
      ? track.albumSlug
      : selectedAlbum.slug;
  const folderName = folderMap[albumSlugForPath] || albumSlugForPath;
  const audioBaseUrl = import.meta.env.VITE_AUDIO_BASE_URL || '';

  const buildFullPath = (libraryPath: string, isWavFormat: boolean): string => {
    const pathParts = libraryPath.split('/');
    const filename = pathParts[pathParts.length - 1];
    const encodedFilename = encodeURIComponent(filename);

    if (isWavFormat) {
      return `${audioBaseUrl}/audio-samples/focus/${encodeURIComponent(folderName)}/WAV/${encodedFilename}`;
    } else {
      return `${audioBaseUrl}/audio-samples/focus/${encodeURIComponent(folderName)}/${encodedFilename}`;
    }
  };

  if (isPro && track.paths.wav) {
    const wavPath = buildFullPath(track.paths.wav, true);
    const mp3Path = buildFullPath(track.paths.mp3, false);
    return audioQuality === 'wav' ? wavPath : mp3Path;
  } else {
    return buildFullPath(track.paths.mp3, false);
  }
}
